export default __webpack_public_path__ + "img/wechata.e3c94117.svg";